import { MATERIAL_USE_EXPORT_HEADERS } from "./materialUsesCsvExport";

const NEEDS_QUOTING = /[",\n\r]/;

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = typeof value === "string" ? value : String(value);
  if (!NEEDS_QUOTING.test(s)) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

function rowsToCsv(headers: readonly string[], rows: Array<Array<unknown>>): string {
  const lines = [headers.join(",")];
  for (const row of rows) {
    lines.push(row.map(escapeCell).join(","));
  }
  return lines.join("\n") + "\n";
}

/** Starter CSV for Part uses bulk import (substitute + finish-variant samples). */
export const EXAMPLE_MATERIAL_USES_BULK_IMPORT_CSV = rowsToCsv(MATERIAL_USE_EXPORT_HEADERS, [
  [
    "FLOOR_34",
    "Flooring 3/4",
    "sheet",
    "",
    "true",
    "substitute",
    "",
    "OSB_34",
    1,
    10,
    "true",
    "false",
    "",
  ],
  [
    "SIDING_USE",
    "Siding finish",
    "sheet",
    "",
    "true",
    "finish_variant",
    "siding",
    "GRAY_SIDING",
    1,
    100,
    "true",
    "true",
    "gray",
  ],
  [
    "SIDING_USE",
    "Siding finish",
    "sheet",
    "",
    "true",
    "finish_variant",
    "siding",
    "CHARCOAL_SIDING",
    1,
    100,
    "true",
    "false",
    "charcoal",
  ],
]);
